export default "__VITE_ASSET__DmNSTIA8__"